module.exports = __webpack_public_path__ + "static/media/logo-rbh-food-icon.e1bed015.png";